export const getLimitValuePoints = (hasPermission, limit = 800) => (hasPermission ? Number.MAX_SAFE_INTEGER : limit)
